const mutation = {
  setShowVerification(state, data) {
    state.showVerification = data;
  },
  setTickets12306List(state, data) {
    state.tickets12306List = data;
  },
  setPassengerInfo(state, data) {
    state.passengerInfo = data;
  },
  setPhotos12306(state, data) {
    state.photos12306 = data;
  },
  setTickets12306NeedCheck(state, data) {
    state.tickets12306NeedCheck = data;
  },
  setTotalPage(state, data) {
    state.totalPage = data;
  },
}

export default mutation